import { Component, OnInit, ContentChildren, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { QueryList } from '@angular/core';
import { Subject } from 'rxjs';
import { ChipComponent } from '../chip/chip.component';

@Component({
  selector: 'app-chips-list',
  templateUrl: './chips-list.component.html',
  styleUrls: ['./chips-list.component.scss'],
})
export class ChipsListComponent implements AfterViewInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @ContentChildren(ChipComponent) chips: QueryList<ChipComponent>;
  constructor() {}

  multiple: boolean = false;

  ngAfterViewInit() {
    this.chips.toArray().forEach((item) => {
      item.select.takeUntil(this.ngUnsubscribe).subscribe((args) => {
        if (args) {
          this.itemSelected(args as any);
        }
      });
    });

    this.chips.changes.subscribe((change) => {
      this.chips.toArray().forEach((item) => {
        //item.select.unsubscribe();
        item.select.takeUntil(this.ngUnsubscribe).subscribe((args) => {
          if (args) {
            this.itemSelected(args as any);
          }
        });
      });
    });
  }

  itemSelected(item: ChipComponent) {
    if (!this.multiple) {
      this.chips.toArray().forEach((item, index) => {
        item.selected = false;
      });
      item.selected = true;
    } else {
      item.selected = !item.selected;
    }
  }

  /**
   * On destroy cancel active subscriptions
   */
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/chips/chips-list/chips-list.component.ts